<template class="h-100">
  <div>
    <!-- Pantalla success  -->
    <section
      v-if="
        submittedSuccessfully &&
        !isError &&
        !isInfoDBC &&
        pageStatus == PAGESTATUS_SUCCESS
      "
      class="alert-success elevation-0"
    >
      <SuccessComponent
        :title="$t('compensation.compensationAccepted')"
      ></SuccessComponent>
      <div class="text-success">
        <div
          v-if="
            jsonPost?.AEBondAccepted === 'false' &&
            jsonPost?.MonetaryAccepted === 'false' &&
            jsonPost?.MilesAccepted === 'false'
          "
        >
          <p>{{ $t("compensation.compensationRejected") }}</p>
        </div>
        <div v-else>
          <p>{{ $t("compensation.formSuccess") }}</p>
        </div>
      </div>
    </section>
    <!-- FIN Pantalla success  -->
    <v-container
      v-if="
        !submittedSuccessfully &&
        !isError &&
        !isInfoDBC &&
        pageStatus == PAGESTATUS_FORM
      "
    >
      <div class="section-heading mt-3">
        <div class="pt-3" style="text-align: left">
          <h1>{{ $t("compensation.selectCompensation") }}</h1>
        </div>
        <div class="subheading">
          <b>{{ $t("compensation.refCompensation") }}: {{ jsonRes?.pyID }}</b>
        </div>
      </div>
      <div>
        <!-- Nombre arriba en pantallas pequeñas -->
        <v-row class="d-md-none">
          <v-col cols="12" style="margin-left: 10px !important">
            <img class="icon-user" src="../../assets/usericon.png" />
            <span class="user-name">{{ passengerData?.BeneficiaryName }}</span>
          </v-col>
        </v-row>

        <!-- Opciones de compensación -->
        <v-row class="compensation-style">
          <!-- Espacio vacío en pantallas grandes para alinear con el nombre -->
          <v-col cols="3" class="d-none d-md-block"></v-col>
          <v-col v-if="jsonRes?.AEBondAmount" cols="2" @click="infoBon">
            {{ $t("compensationSelection.bono") }}
            <img
              class="icon-style"
              src="../../assets/icons-action-alert@2x.png"
            />
          </v-col>
          <v-col v-if="jsonRes?.MonetaryMaxAmount" cols="2" @click="infoMon">
            {{ $t("compensationSelection.monetary") }}
            <img
              class="icon-style"
              src="../../assets/icons-action-alert@2x.png"
            />
          </v-col>
          <v-col v-if="jsonRes?.MilesAmount" cols="2" @click="infoMil">
            {{ $t("compensationSelection.millas") }}
            <img
              class="icon-style"
              src="../../assets/icons-action-alert@2x.png"
            />
          </v-col>
          <v-col cols="3" @click="infoRefuse">
            {{ $t("compensationSelection.refuse") }}
            <img
              class="icon-style"
              src="../../assets/icons-action-alert@2x.png"
            />
          </v-col>
        </v-row>
        <!-- Importes según las opciones de compensación -->
        <v-radio-group v-model="optionSelected">
          <v-row class="amounts-style">
            <!-- Nombre en su posición original en pantallas grandes -->
            <v-col cols="3" class="d-none d-md-flex align-center">
              <img class="icon-user2" src="../../assets/usericon.png" />
              <span class="user-name">{{
                passengerData?.BeneficiaryName
              }}</span>
            </v-col>

            <v-col cols="2" v-if="jsonRes?.AEBondAmount">
              <v-radio
                class="custom-radio"
                :label="formatAmount(jsonRes?.AEBondAmount) + ' €'"
                :value="1"
              ></v-radio>
            </v-col>
            <v-col cols="2" v-if="jsonRes?.MonetaryMaxAmount">
              <v-radio
                class="custom-radio"
                :label="formatAmount(jsonRes?.MonetaryMaxAmount) + ' €'"
                :value="2"
              ></v-radio>
            </v-col>
            <v-col cols="2" v-if="jsonRes?.MilesAmount">
              <v-radio
                class="custom-radio"
                :label="
                  formatMillas(jsonRes?.MilesAmount) +
                  ' ' +
                  $t('compensation.miles')
                "
                :value="3"
              ></v-radio>
            </v-col>
            <v-col cols="3" class="custom-col">
              <v-radio
                class="custom-radio"
                :label="$t('compensationSelection.milDes')"
                :value="4"
              ></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>
      </div>
      <ValidationObserver ref="clientFormObs" tag="form" v-slot="{ valid }">
        <div v-if="optionSelected === 1" class="data-form">
          <h4>{{ $t("compensationSelection.dbcCbon") }}</h4>
          <h4 class="bono-title">
            {{ $t("compensationSelection.cbonTitle") }}
          </h4>
          <NewDataClientComponent ref="dataClient" />
          <div class="d-sm-flex">
            <v-btn
              class="btn-bank"
              style="margin-right: unset"
              :disabled="btnSendDisabled(!valid)"
              @click="openDialog"
              >{{ $t("compensation.confirmButtonText") }}</v-btn
            >
          </div>
        </div>
      </ValidationObserver>
      <ValidationObserver ref="bankFormObs" tag="form" v-slot="{ valid }">
        <div v-if="optionSelected === 2" class="data-form">
          <h4>{{ $t("compensation.bankDetailsHeader") }}</h4>
          <DynamicForm
            ref="formMonetary"
            :values="defaultValues"
            @form-validity="onFormValidityFile"
          />
          <div class="d-sm-flex">
            <v-btn
              class="btn-bank"
              style="margin-right: unset"
              @click="openDialog"
              :disabled="btnSendDisabled(!valid) || !isFormValidFile"
              >{{ $t("compensation.confirmButtonText") }}</v-btn
            >
          </div>
        </div>
      </ValidationObserver>
      <div
        class="d-sm-flex"
        v-if="optionSelected === 3 || optionSelected === 4"
      >
        <v-btn
          class="btn-bank"
          style="margin-right: unset"
          @click="openDialog"
          :disabled="btnSendDisabled(!valid)"
          >{{ $t("compensation.confirmButtonText") }}</v-btn
        >
      </div>
      <div
        class="d-sm-flex"
        v-if="
          optionSelected !== 1 &&
          optionSelected !== 2 &&
          optionSelected !== 3 &&
          optionSelected !== 4
        "
      >
        <v-btn
          class="btn-bank"
          style="margin-right: unset"
          :disabled="btnSendDisabled(!valid)"
          >{{ $t("compensation.confirmButtonText") }}</v-btn
        >
      </div>
      <div class="info-style" v-if="!optionSelected">
        <h4 class="info-title">{{ $t("compensationSelection.info") }}</h4>
        <p class="info-Des">
          {{ $t("compensationSelection.infoDes") }}
          <strong>{{ $t("compensationSelection.infoDes2") }}</strong>
          <!-- Renderiza condicionalmente el infoDes2en solo si el idioma actual es inglés-->
          <span v-if="isEnglish">{{
            $t("compensationSelection.infoDes2en")
          }}</span>
          <br />
          {{ $t("compensationSelection.infoDes3") }}
          <strong>{{ $t("compensationSelection.infoDes4") }}</strong>
          {{ $t("compensationSelection.infoDes5") }}
        </p>
      </div>
    </v-container>
    <!-- Popup errores SAP para monetary  -->
    <BankDetailsSapErrors
      :open="bankDetailsSapErrorsDialog.open"
      @close="bankDetailsSapErrorsDialogToggle"
      :errors="bankDetailsSapErrorsDialog.errors"
    />
    <!-- Popup del icono de "i" información de cada compensación  -->
    <v-dialog v-model="infoDialogBon" width="720" max-width="720">
      <v-card>
        <v-card-text class="pt-3">
          <div style="display: flex; flex-direction: column">
            <v-icon style="align-self: flex-end" @click="infoDialogBon = false"
              >close</v-icon
            >
          </div>
          <TcAebond :dialog="disableDialog"></TcAebond>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="infoDialogMon" width="500">
      <v-card>
        <v-card-text class="pt-3">
          <div class="dialog-style">
            <v-icon style="align-self: flex-end" @click="infoDialogMon = false"
              >close</v-icon
            >
          </div>
          <TcMonetary :dialog="disableDialog"></TcMonetary>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="infoDialogMil" width="500">
      <v-card>
        <v-card-text class="pt-3">
          <div class="dialog-style">
            <v-icon style="align-self: flex-end" @click="infoDialogMil = false"
              >close</v-icon
            >
          </div>
          <TcMiles :dialog="disableDialog"></TcMiles>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="infoDialogRefuse" width="500">
      <v-card>
        <v-card-text class="pt-3">
          <div class="dialog-style">
            <v-icon
              style="align-self: flex-end"
              @click="infoDialogRefuse = false"
              >close</v-icon
            >
          </div>
          <TcRefuse :dialog="disableDialog"></TcRefuse>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Fin popup del icono de "i" información de cada compensación  -->
    <!-- popup para confirmar la compensación seleccionada -->
    <v-dialog persistent v-model="dialogInf" max-width="529" width="529">
      <v-card>
        <v-card-text class="pt-3">
          <div style="display: flex; flex-direction: column">
            <v-icon style="align-self: flex-end" @click="dialogInf = false"
              >close</v-icon
            >
          </div>
          <div
            class="text-center"
            style="display: flex; flex-direction: column"
          >
            <div
              v-if="
                optionSelected === 1 ||
                optionSelected === 2 ||
                optionSelected === 3
              "
            >
              <h2 class="mb-3 send-dialog-title">
                {{ $t("compensation.confirmText") }}
              </h2>
              <p class="send-dialog-disclaimer mb-2">
                {{ $t("compensation.compensationSelected") }}
              </p>
              <h3 class="send-dialog-resume mb-2">
                {{ this.jsonRes?.CompensationDetails?.BeneficiaryName }}
              </h3>
              <div class="send-dialog-resume">
                <div v-if="optionSelected === 1">
                  <h3 class="send-dialog-disclaimer mb-2">
                    {{ $t("compensationSelection.bono") }} -
                    {{ formatAmount(jsonRes?.AEBondAmount) + " €" }}
                  </h3>
                </div>
                <div v-if="optionSelected === 2">
                  <h3 class="send-dialog-disclaimer mb-2">
                    {{ $t("compensationSelection.monetary") }} -
                    {{ formatAmount(jsonRes?.MonetaryMaxAmount) + " €" }}
                  </h3>
                </div>
              </div>
              <div v-if="optionSelected === 3">
                <h3 class="send-dialog-disclaimer mb-2">
                  {{ $t("compensationSelection.millas") }} -
                  {{
                    formatMillas(this.jsonRes?.MilesAmount) +
                    " " +
                    $t("compensation.miles")
                  }}
                </h3>
              </div>
              <div class="send-dialog-disclaimer mt-2">
                <p style="font-size: 0.9em">
                  {{ $t("compensation.disclaimer") }}
                </p>
              </div>
            </div>
            <div v-if="optionSelected === 4">
              <div class="send-dialog-disclaimer mt-2">
                <h2 class="mb-3 send-dialog-title">
                  {{ $t("compensationSelection.TcRefuseTitle") }}
                </h2>
                <p style="font-size: 0.9em">
                  {{ $t("compensationSelection.TcRefuseContent") }}
                </p>
              </div>
            </div>
            <v-btn class="btn-bank" @click="sendCompensationSelected">
              {{ $t("compensation.confirmButtonText") }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Fin popup para confirmar la compensacion seleccionada -->
    <!-- Pantalla de error -->
    <ErrorDBC
      v-if="isError"
      class="alert-component"
      :title="isError149 ? $t('error_dbc.title1') : $t('error_dbc.title3')"
      :subtitle="$t('error_dbc.subtitle1')"
    />
    <ErrorInfoDBC
      v-if="isInfoDBC"
      class="alert-component"
      :title="$t('error_dbc.title2')"
      :subtitle="isError3 ? $t('error_dbc.subtitle3') : ''"
      :subtitle2="
        isError3 ? $t('error_dbc.subtitle1') : $t('error_dbc.subtitle2')
      "
    />
    <ErrorDBC
      v-if="isErrorFile"
      class="alert-component"
      :title="isError149 ? $t('error_dbc.title1') : $t('error_dbc.title3')"
      :subtitle="$t('error.error5XXC')"
    />
  </div>
</template>

<script>
import ErrorDBC from "./ErrorDBC.vue";
import ErrorInfoDBC from "./ErrorInfoDBC.vue";
import Api from "@/api/api.js";
// import ConfirmationComponent from "../ConfirmationComponent.vue";
import BankDetailsSapErrors from "../dialogs/BankDetailsSapErrors.vue";
import TcAebond from "../compensation/TcAebond.vue";
import TcMonetary from "../compensation/TcMonetary.vue";
import TcMiles from "../compensation/TcMiles.vue";
import TcRefuse from "./TcRefuse.vue";
import DynamicForm from "@/components/dynamic/DynamicForm.vue";
import NewDataClientComponent from "./NewDataClientComponent.vue";
import { ValidationObserver } from "vee-validate";
import { useUiStore } from "@/stores/uiStore";
import { mapStores, mapWritableState } from "pinia";
import { useTokenStore } from "@/stores/tokenStore";
import { useCompensationStore } from "@/stores/compensationStore";
import { useCountriesStore } from "@/stores/countriesStore";
import SuccessComponent from "./SuccessComponent.vue";

export default {
  name: "newCompensationComponente",
  components: {
    ErrorDBC,
    ErrorInfoDBC,
    TcAebond,
    TcMonetary,
    TcMiles,
    TcRefuse,
    DynamicForm,
    NewDataClientComponent,
    ValidationObserver,
    BankDetailsSapErrors,
    SuccessComponent,
  },
  data: () => ({
    PAGESTATUS_FORM: 0,
    PAGESTATUS_SUCCESS: 1,
    PAGESTATUS_LOADERROR: 2,
    pageStatus: null,
    infoDialogBon: false,
    infoDialogMon: false,
    infoDialogMil: false,
    infoDialogRefuse: false,
    optionSelected: null,
    defaultValues: null,
    valid: true,
    dialogMil: false,
    passengerInfo: {},
    currencyCountries: null,
    formDataClient: null,
    formDataBank: null,
    formDataMil: null,
    dialogInf: false,
    formDataRefuse: null,
    submittedSuccessfully: false,
    isError: false,
    isError149: false,
    isError6: false,
    isError3: false,
    isInfoDBC: false,
    bankDetailsSapErrorsDialog: {
      open: false,
      errors: [],
    },
    msgRefuse: false,
    isErrorFile: false,
    uploadResponse: null,
    isFormValidFile: true,
  }),
  computed: {
    // Propiedad para verificar si el idioma actual es inglés
    isEnglish() {
      return this.$i18n.locale === "en";
    },
    ...mapStores(useTokenStore, useUiStore, useCountriesStore),
    ...mapWritableState(useCompensationStore, [
      "jsonRes",
      "jsonPost",
      "passengerData",
      "pyId",
    ]),
    isExpiredToken() {
      // return false;
      return this.tokenStore?.isExpiredToken;
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    setTimeout(() => {
      this.loadBankDetails();
    }, 1000);
    //this.loadBankDetails();
  },
  methods: {
    onFormValidityFile(isValid) {
      this.isFormValidFile = isValid;
    },
    disableDialog() {
      this.infoDialogBon = false;
      this.infoDialogMon = false;
      this.infoDialogMil = false;
      this.infoDialogRefuse = false;
    },
    infoBon() {
      this.infoDialogBon = true;
    },
    infoMon() {
      this.infoDialogMon = true;
    },
    infoMil() {
      this.infoDialogMil = true;
    },
    infoRefuse() {
      this.infoDialogRefuse = true;
    },
    openDialog() {
      this.dialogInf = true;
    },
    btnSendDisabled(valid) {
      if (
        this.optionSelected !== 1 &&
        this.optionSelected !== 2 &&
        this.optionSelected !== 3 &&
        this.optionSelected !== 4
      ) {
        return !valid;
      }
      if (this.$refs.clientFormObs) {
        return valid;
      }
      if (this.$refs.bankFormObs) {
        return valid;
      }
      if (valid) {
        this.dialogInf = true;
      }
    },
    btnBonoDisabled(valid) {
      if (this.$refs.clientFormObs) {
        return valid;
      }
    },
    btnMonetaryDisabled(valid) {
      if (this.$refs.bankFormObs) {
        return valid;
      }
    },
    errorForm(e) {
      if (e?.response?.status === 400) {
        this.hasSapErrors(e?.response?.data?.errorDescription?.split(";"));
        this.pageStatus = this.PAGESTATUS_FORM;
      } else if (e?.response?.status === 404) {
        this.setCustomError({
          customError: this.$t("error.error404"),
        });
      } else if (e?.response?.status === 409) {
        this.setCustomError({
          customError: this.$t("error.error409"),
        });
      } else if (e?.response?.status === 410) {
        this.setCustomError({
          customError: this.$t("error.error410C"),
        });
      } else if (e?.response?.status === 423) {
        this.setCustomError({
          customError: this.$t("error.error423C"),
        });
      } else if (e?.response?.status) {
        this.setCustomError({ errorCode: e.response.status });
      }
      this.uiStore.changeSpinner(false);
    },
    async getData() {
      this.uiStore.changeSpinner(true);
      try {
        const response = await Api.getNewCompensation(
          this.tokenStore.caseId,
          this.tokenStore.token
        );
        this.jsonRes = response.data;
        this.passengerData = this.jsonRes?.CompensationDetails;
        if (response?.data?.StatusCode !== "0") {
          this.errorPega(response);
        } else {
          this.pageStatus = this.PAGESTATUS_FORM;
        }
        this.uiStore.changeSpinner(false);
      } catch (e) {
        this.errorForm(e);
      }
    },
    notErrorScreen() {
      this.isError = false;
      this.isError149 = false;
      this.isError6 = false;
      this.isError3 = false;
      this.isInfoDBC = false;
    },
    errorPega(error) {
      if (error?.data?.StatusCode === "1") {
        this.isError = true;
        this.isError149 = true;
      } else if (error?.data?.StatusCode === "2") {
        this.isInfoDBC = true;
        this.isError3 = false;
      } else if (error?.data?.StatusCode === "3") {
        this.isInfoDBC = true;
        this.isError3 = true;
      } else if (error?.data?.StatusCode === "4") {
        this.isError = true;
        this.isError149 = true;
      } else if (error?.data?.StatusCode === "6") {
        this.isError = true;
        this.isError149 = false;
      } else if (error?.data?.StatusCode === "7") {
        this.isInfoDBC = true;
        this.isError3 = false;
      } else if (error?.data?.StatusCode === "9") {
        this.isError = true;
        this.isError149 = true;
      } else if (error?.data?.StatusCode === "10") {
        const sapErrors = this.hasSapErrors(
          error?.data?.ErrorsSAP?.map((error) => error?.Description)
        );
        this.hasSapErrors(sapErrors);
        this.submittedSuccessfully = false;
        this.notErrorScreen();
        this.pageStatus = this.PAGESTATUS_FORM;
      } else {
        return;
      }
    },

    setCustomError({ errorCode, customError = "errorsSap.TPY-0100" }) {
      let error = "";
      if (!errorCode && customError) {
        error = customError;
      }
      if (errorCode) {
        let status = errorCode.toString();
        if (status.match(/^5\d{2}$/)) status = "5XXC";
        error = `error.error${status}`;
        if (!this.$te(error)) error = customError;
      }
      this.uiStore.setError({
        message: this.$t(error),
      });
    },
    loadBankDetails() {
      try {
        this.currencyCountries = this.jsonRes?.pyItemGroup?.map((i) => i?.Code);
        this.countriesStore.filterWithAvailableCurrency(this.currencyCountries);
      } catch (error) {
        console.error(error);
      }
    },
    formatAmount(amount) {
      const amountTrunc = Math.trunc(amount);
      const hasDecimal = amount !== amountTrunc;
      if (hasDecimal) {
        const amountRound = Math.round(amount * 100) / 100;
        return amountRound.toLocaleString();
      } else {
        return amountTrunc.toLocaleString();
      }
    },
    formatMillas(amount) {
      const amountTrunc = Math.trunc(amount);
      return amountTrunc.toLocaleString();
    },
    /**
     * Este método ejecuta un componente de submit según la compensation seleccionada
     */
    sendCompensationSelected() {
      if (this.optionSelected === 1) {
        this.submitFormBond();
      } else if (this.optionSelected === 2) {
        this.submitFormMonetary();
      } else if (this.optionSelected === 3) {
        this.submitFormMil();
      } else {
        this.submitFormRefuse();
      }
    },
    /** Mapeo Json del post de bono y monetaria*/
    mapClientForm() {
      const dataClient = this.$refs.dataClient.dataClient;
      this.formDataClient = { ...this.jsonRes };
      this.formDataClient.CompensationDetails.AEBondAccepted = "true";
      this.formDataClient.CompensationDetails.BeneficiaryDocNumber =
        dataClient["documentNumber"];
      this.formDataClient.CompensationDetails.BeneficiaryDocType =
        dataClient["documentTypes"];
      this.formDataClient.CompensationDetails.BeneficiaryFirstName =
        dataClient["firstName"];
      this.formDataClient.CompensationDetails.BeneficiaryLastName =
        dataClient["lastName"];
      this.formDataClient.CompensationDetails.BeneficiarySecondLastName =
        dataClient["secondLastName"];
      this.formDataClient.pyItemGroup = "";
      delete this.formDataClient.CompensationDetails
        .AEBondCompensationAcceptedText;
      delete this.formDataClient.CompensationDetails
        .MonetaryCompensationAcceptedText;
    },
    mapBankForm() {
      const bankForm = this.$refs.formMonetary.dataForSend;
      this.formDataBank = { ...this.jsonRes };
      this.formDataBank.CompensationDetails.MonetaryAccepted = "true";
      this.formDataBank.CompensationDetails.CountryCode =
        bankForm["CountryCode"];
      this.formDataBank.CompensationDetails.AccountHolderName =
        bankForm["AccountHolderName"] || "";
      this.formDataBank.CompensationDetails.AccountHolderDocType =
        bankForm["AccountHolderDocType"] || "";
      this.formDataBank.CompensationDetails.AccountHolderDocNumber =
        bankForm["AccountHolderDocNumber"] || "";
      this.formDataBank.CompensationDetails.AccountNumber =
        bankForm["AccountNumber"] || "";
      this.formDataBank.CompensationDetails.BankName =
        bankForm["BankName"] || "";
      this.formDataBank.CompensationDetails.BankCode =
        bankForm["BankCode"] || "";
      this.formDataBank.CompensationDetails.SWIFT = bankForm["SWIFT"] || "";
      this.formDataBank.CompensationDetails.SWIFT2 = bankForm["SWIFT2"] || "";
      this.formDataBank.CompensationDetails.IBAN = bankForm["IBAN"] || "";
      this.formDataBank.CompensationDetails.RefBank = bankForm["RefBank"] || "";
      this.formDataBank.CompensationDetails.ControlDigit =
        bankForm["ControlDigit"] || "";
      this.formDataBank.CompensationDetails.AccountTypeBankDetails =
        bankForm["AccountTypeBankDetails"] || "";
      this.formDataBank.CompensationDetails.AddressLine2 =
        bankForm["AddressLine2"] || "";
      this.formDataBank.CompensationDetails.AccountCurrency =
        bankForm["AccountCurrency"] || "";
      let formattedFileName = "";
      if (bankForm.uploadedFile && bankForm.uploadedFile.name) {
        formattedFileName = bankForm.uploadedFile.name
          .normalize("NFD") // Descompone caracteres con tildes
          .replace(/[\u0300-\u036f]/g, "") // Elimina marcas diacríticas
          .replace(/ñ/g, "n") // Reemplaza ñ con n
          .replace(/Ñ/g, "N")
          .replace(/-/g, "_") // Reemplaza guiones con guiones bajos
          .replace(/[^a-zA-Z0-9._-]/g, "_"); // Reemplaza caracteres especiales con _
      }
      this.formDataBank.CompensationDetails.uploadedFile = formattedFileName;

      this.formDataBank.pyItemGroup = "";
      delete this.formDataBank.CompensationDetails
        .AEBondCompensationAcceptedText;
      delete this.formDataBank.CompensationDetails
        .MonetaryCompensationAcceptedText;
    },
    /** Inicio de los métodos de post */
    async submitFormBond() {
      try {
        this.dialogInf = false;
        this.mapClientForm();
        this.uiStore.changeSpinner(true);
        const response = await Api.sendCompensationData(this.formDataClient);
        this.commonMethod(response);
      } catch (e) {
        this.errorForm(e);
      }
    },
    async submitFormMonetary() {
      this.dialogInf = false;
      const bankForm = this.$refs.formMonetary.dataForSend;

      const uploadedFile = bankForm.uploadedFile;
      if (uploadedFile && uploadedFile.name) {
        try {
          this.uploadResponse = await Api.uploadFileWithId(
            uploadedFile,
            this.jsonRes.pyID
          );
        } catch (error) {
          this.setCustomError({
            customError: this.$t("error.error5XXC"),
          });
        }
      }
      if (this.uploadResponse?.status === 200) {
        try {
          this.mapBankForm();
          this.uiStore.changeSpinner(true);
          const response = await Api.sendCompensationData(this.formDataBank);
          this.commonMethod(response);
        } catch (error) {
          console.error(error);
          this.errorForm(error);
        }
      } else {
        this.isErrorFile = true; // Mostrar pantalla de error
        this.uiStore.changeSpinner(false);
        this.setCustomError({
          customError: this.$t("error.error5XXC"),
        });
      }
    },
    async submitFormMil() {
      try {
        this.dialogInf = false;
        this.formDataMil = { ...this.jsonRes };
        this.formDataMil.CompensationDetails.MilesAccepted = "true";
        this.formDataMil.pyItemGroup = "";
        delete this.formDataMil.CompensationDetails
          .AEBondCompensationAcceptedText;
        delete this.formDataMil.CompensationDetails
          .MonetaryCompensationAcceptedText;
        this.uiStore.changeSpinner(true);
        const response = await Api.sendCompensationData(this.formDataMil);
        this.commonMethod(response);
      } catch (e) {
        this.errorForm(e);
      }
    },
    async submitFormRefuse() {
      try {
        this.dialogInf = false;
        this.formDataRefuse = { ...this.jsonRes };
        this.formDataRefuse.pyItemGroup = "";
        delete this.formDataRefuse.CompensationDetails
          .AEBondCompensationAcceptedText;
        delete this.formDataRefuse.CompensationDetails;
        this.uiStore.changeSpinner(true);
        const response = await Api.sendCompensationData(this.formDataRefuse);
        this.commonMethod(response);
      } catch (e) {
        this.errorForm(e);
      }
    },
    /** Fin de los métodos de post */

    /** Método común entre los métodos de post para mostrar la pantalla de success o la pantalla  de error*/
    commonMethod(e) {
      this.jsonPost = e.data.CompensationDetails;
      if (e.data.StatusCode === "0") {
        this.submittedSuccessfully = true;
        this.pageStatus = this.PAGESTATUS_SUCCESS;
      } else {
        this.errorPega(e);
      }
      this.uiStore.changeSpinner(false);
    },
    /** Método para cerrar popup de error de Sap  */
    bankDetailsSapErrorsDialogToggle() {
      this.bankDetailsSapErrorsDialog.open =
        !this.bankDetailsSapErrorsDialog.open;
    },
    /** Método para mostrar el popup con el mensaje de error de SAP que viene
     * en la respuesta de la petición del post de datos bancarios
     * */
    hasSapErrors(sapErrors) {
      if (!sapErrors) return;
      this.bankDetailsSapErrorsDialog = {
        open: true,
        errors: sapErrors,
      };
    },
  },
};
</script>

<style scoped lang="scss">
h1 {
  color: #0d0d0d;
  font-family: Aeradar-Bold, arial, sans-serif;
  line-height: 1;
  margin-bottom: 10px;
}

.section-heading {
  color: #0f2367;
  font-family: AERadar;
  font-size: 16px;
  padding-bottom: 15px;
}

.ae-description {
  font-size: 14px;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;
  margin-bottom: 16px;
  text-decoration: none;
  color: #0f2367;
}

.compensation-style {
  cursor: pointer;
  display: flex;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #0f2367;
  line-height: 24px;
  align-items: stretch;
  justify-content: space-around;
}

.col {
  margin: 5px 0 !important;
  padding: 0 !important;
}

.amounts-style {
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
}

.icon-style {
  width: 12px;
  height: 12px;
  margin-top: 0;
  margin-left: 1px;
}

.dialog-style {
  display: flex;
  overflow-x: hidden;
  overflow-y: hidden;
  flex-direction: column;
}

.user-name {
  font-family: Aeradar-Bold, sans-serif;
  text-align: left;
  color: #2d69e1;
  font-size: 16px;
}

.radio-style {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Aeradar-Bold, sans-serif;
  font-size: 16px;
}

.icon-user,
.icon-user2 {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.icon-user2 {
  margin-left: 10px;
}

.data-form {
  background-color: #f6f6f6;
  padding: 28px;
  border-radius: 10px;
  @media (max-width: 992px) {
    padding: 12px;
  }
}

.btn-confirm {
  color: white;
  background-color: #2d69e1;
  margin-top: 10px;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  height: 48px;
  border-radius: 14px;
  font-size: 16px !important;
  padding: 12px 24px;
}

.info-style {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%; // Asegura que el contenedor ocupe el 100% del ancho del viewport
  max-width: 1200px; // Limita el ancho máximo del contenedor
  margin: 0 auto; // Centra el contenedor en el viewport
  padding: 5em 2em; // Reduce padding horizontal para más ancho

  @media (max-width: 1200px) {
    padding: 5em 2em; // Ajusta padding horizontal para pantallas medianas
  }

  @media (max-width: 768px) {
    padding: 3em 1.5em; // Ajusta padding horizontal para pantallas pequeñas
  }

  @media (max-width: 480px) {
    padding: 2em 1em; // Ajusta padding horizontal para móviles
  }
}

.info-title {
  color: #2d69e1;
  font-size: 30px;
  margin-bottom: 20px;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;

  @media (max-width: 768px) {
    font-size: 24px; // Ajusta tamaño del texto en pantallas medianas
  }

  @media (max-width: 480px) {
    font-size: 20px; // Ajusta tamaño del texto en pantallas móviles
  }
}

.info-Des {
  font-size: 18px;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;
  width: 100%; // Asegura que el texto ocupe todo el ancho disponible
  max-width: 100%; // Evita desbordamientos
  text-align: center; // Centra el texto
  margin: 0 auto; // Centra el texto dentro del contenedor
  padding: 0 1em; // Agrega padding para evitar que el texto toque los bordes

  @media (max-width: 1200px) {
    font-size: 16px; // Ajusta tamaño del texto para pantallas medianas
    padding: 0 1em; // Ajusta padding
  }

  @media (max-width: 768px) {
    font-size: 14px; // Ajusta tamaño del texto para pantallas pequeñas
    padding: 0 0.5em; // Ajusta padding
  }

  @media (max-width: 480px) {
    font-size: 12px; // Ajusta tamaño del texto para móviles
    padding: 0 0.25em; // Ajusta padding
  }
}

.bono-title {
  font-family: AERadar;
  font-size: 20px;
  margin: 10px 0;
  color: #0f2367;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 480px) {
    font-size: 16px;
  }
}

.send-dialog-title {
  font-family: Aeradar-Bold, sans-serif;
  font-size: 22px;
  line-height: 32px;
  margin-bottom: 12px;
  color: #2d69e1;
  @media (max-width: 768px) {
    font-size: 20px;
  }
  @media (max-width: 480px) {
    font-size: 18px;
  }
}

.send-dialog-resume {
  font-family: Lato, sans-serif;
  font-size: 16px;
  line-height: 20px;
  color: #000;
}

.alert-component {
  margin: 12em !important;
  display: flex;
  justify-content: center;
}

.alert-success {
  width: fit-content;
  box-shadow: 0px 5px 10px rgba(204, 204, 204, 0.3);
  padding: 50px;
  border-radius: 20px;
  margin: 5em auto;
  @media (max-width: 768px) {
    padding: 30px;
  }
  @media (max-width: 480px) {
    padding: 20px;
  }
}

.text-success {
  font-family: Lato;
  font-size: 18px;
  line-height: 26px;
  color: #0d0d0d;
  @media (max-width: 600px) {
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media (max-width: 600px) {
  ::v-deep .custom-radio .v-input--selection-controls__input {
    transform: scale(0.8);
  }
  ::v-deep .custom-col {
    max-width: 100% !important;
  }
  ::v-deep .v-container {
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;
  }
  ::v-deep .v-row {
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;
  }
  ::v-deep .v-input--selection-controls__ripple {
    max-width: 100% !important;
  }
}
</style>
